import React, { useState } from "react";
import PropTypes from "prop-types";
import Tooltip from "@mui/material/Tooltip";
import { Copy, Check } from "lucide-react";
import IconButton from "@mui/material/IconButton";
import "./ChargerDisplay.scss";

function ChargerDisplay({ serialNumber, onClick, showSidePanel = true }) {
  const [copied, setCopied] = useState(false);

  if (!serialNumber) return "-";

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(serialNumber);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      // Clipboard write failed
    }
  };

  return (
    <div className="ocpp-charger-display">
      IQ EV Charger:
      {showSidePanel ? (
        <>
          <Tooltip title="View charger details" arrow placement="top">
            <button
              type="button"
              className="ocpp-charger-serial"
              onClick={onClick}
              aria-label={`View charger details for ${serialNumber}`}
            >
              {serialNumber}
            </button>
          </Tooltip>

          <IconButton size="small" className="ocpp-copy-button" onClick={handleCopy} aria-label="Copy serial number">
            {copied ? <Check size={18} /> : <Copy size={18} />}
          </IconButton>
        </>
      ) : (
        <span className="ocpp-charger-serial-without-side-panel">{serialNumber}</span>
      )}
    </div>
  );
}

ChargerDisplay.propTypes = {
  serialNumber: PropTypes.string,
  onClick: PropTypes.func,
  showSidePanel: PropTypes.bool,
};

export default ChargerDisplay;
